import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CardOrdersComponent } from '@src/app/features/card-orders/card-orders/card-orders.component';
import { AddCardOrderComponent } from '@src/app/features/card-orders/add-card-order/add-card-order.component';
import { ViewCardOrderComponent } from '@src/app/features/card-orders/view-card-order/view-card-order.component';

const routes: Routes = [
  { path: '', component: CardOrdersComponent },
  { path: 'add', component: AddCardOrderComponent },
  { path: ':cardOrderId', component: ViewCardOrderComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CardOrderingRoutingModule { }
